import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { seriesPath } from 'src/app/utils/series-url';

/**
 * In-app fallback for legacy URLs whose new address cannot be expressed with a
 * plain `redirectTo` (e.g. /new-release/26 -> /plates/26-reg). Real visitors and
 * crawlers get a 301 from the CDN edge before the app loads; this only covers
 * in-app navigations and hosts without the edge function.
 */
@Component({
  selector: 'pla-legacy-redirect',
  template: '',
})
export class LegacyRedirectComponent {
  constructor(route: ActivatedRoute, router: Router) {
    const target = route.snapshot.data['legacyTarget'];
    const params = route.snapshot.params;
    let url = '/';
    if (target === 'series') url = seriesPath(params['releaseYear']);
    router.navigateByUrl(
      router.createUrlTree([url], { queryParams: route.snapshot.queryParams }),
      { replaceUrl: true }
    );
  }
}
